"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemAdditionalInfo = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const AdditionalInfo = (0, _mui.styled)('span')(({
  theme
}) => ({
  display: 'inline-grid',
  paddingLeft: theme.spacing(1),
  gridTemplateColumns: 'auto auto',
  gap: theme.spacing(1),
  alignItems: 'center'
}));
const Separator = (0, _mui.styled)('span')(() => ({
  fontSize: '2rem',
  lineHeight: 0.5
}));
const ItemAdditionalInfo = ({
  infoText,
  itemTestId
}) => {
  const theme = (0, _mui.useTheme)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(AdditionalInfo, {
    "data-testid": `${itemTestId}-info-addon`,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Separator, {
      children: "\xB7"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "caption",
      color: theme.palette.text.secondary,
      children: infoText
    })]
  });
};
exports.ItemAdditionalInfo = ItemAdditionalInfo;
